import { render, staticRenderFns } from "./ForecastProject.vue?vue&type=template&id=2131fed4&scoped=true"
import script from "./ForecastProject.vue?vue&type=script&lang=js"
export * from "./ForecastProject.vue?vue&type=script&lang=js"
import style0 from "./ForecastProject.vue?vue&type=style&index=0&id=2131fed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131fed4",
  null
  
)

export default component.exports